/* eslint-disable camelcase */
import bwipjs from 'bwip-js';

import { BarcodeParams } from '~/renderer/utils/transform-html/types';

export async function generateBarcode({
  number,
  hide_text = false,
  noframe = false,
  encoding = 'ean13',
}: BarcodeParams) {
  const emptyCanvas = document.createElement('canvas');

  const canvas = bwipjs.toCanvas(emptyCanvas, {
    bcid: encoding,
    text: number,
    showborder: !noframe,
    height: 10,
    includetext: !hide_text,
  });

  return canvas.toDataURL('image/png');
}
